<template>
  <div class="container_item">
    <el-form label-width="88px" ref="orgDetail" size="small">
      <div class="btns flex">
        <el-button
          type="primary"
          size="small"
          @click="editBtn"
          icon="el-icon-edit"
        ></el-button>
        <el-button
          type="primary"
          size="small"
          @click="deleteBtn"
          icon="el-icon-delete"
        ></el-button>
      </div>
      <el-form-item label="机构名:">
        <template v-if="isEdit">
          <el-input v-model="orgInfo.label" placeholder="请输入机构名称">
          </el-input>
        </template>
        <template v-else>
          {{ orgInfo.label || "--" }}
        </template>
      </el-form-item>
      <el-form-item label="上级机构:">
        <template v-if="isEdit">
          <el-input v-model="orgInfo.pname" placeholder="请输入上级机构">
          </el-input>
        </template>
        <template v-else>
          {{ orgInfo.pname || "--" }}
        </template>
      </el-form-item>
      <el-form-item label="创建日期:">
        <template v-if="isEdit">
          <el-date-picker
            v-model="orgInfo.created_at"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </template>
        <template v-else>
          {{ orgInfo.created_at || "--" }}
        </template>
      </el-form-item>
      <el-form-item label="描述:">
        <template v-if="isEdit">
          <el-input
            v-model="orgInfo.describe"
            type="textarea"
            :rows="5"
            placeholder="请输入机构描述"
          >
          </el-input>
        </template>
        <template v-else>
          {{ orgInfo.describe || "--" }}
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "orgDetail",
  data() {
    return {
      isEdit: false,
    };
  },
  props: {
    orgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orgId: {
      type: String,
      default: "",
    },
  },
  watch: {
    orgId: {
      handler(newV, oldV) {
        if (newV) {
          this.getOrgInfo();
        }
      },
    },
  },
  components: {},
  methods: {
    editBtn() {
      // this.isEdit = !this.isEdit;
      this.$emit("editOrg", 2);
    },
    deleteBtn() {
      this.$emit("deleteOrg");
    },
    getOrgInfo() {
      // 根据id获取详情
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.container_item {
  padding: 20px 0;
  ::v-deep .el-form-item {
    display: flex;
    .el-form-item__label {
      font-weight: bold;
    }
    .el-form-item__content {
      flex: 1;
      margin-left: 0 !important;
    }
  }
}
.btns {
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
